import { Select, Input, Button, notification } from 'antd';
import axios from "axios";
import { SafetyCertificateOutlined, UserOutlined, PhoneOutlined } from '@ant-design/icons'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import './UserManagement.css'
import { useContext, useEffect, useState } from 'react';
import { validEmail, validPhoneNumber } from '../utils/RegExUtility'
import { AppContext } from '../AppContext'
import { useQueryClient } from 'react-query'
import tr from '../i18n'
import { hasAccess, hasRoles, ROLES } from "../utils/AccessLevels";

const UserManagement = () => {
    const [invitationEmail, setInvitationEmail] = useState(null)
    const [invitationRole, setInvitationRole] = useState(null)
    const [invitationName, setInvitationName] = useState(null)
    const queryClient = useQueryClient()
    const navigate = useNavigate();

    // const [invitationPhone, setInvitationPhone] = useState(null)
    const { role } = useContext(AppContext)

    const sendInvitation = async () => {
        if (!invitationEmail || !invitationRole) return;

        if (!validEmail.test(invitationEmail) && !validPhoneNumber.test(invitationEmail)) {
            return notification.error({
                message: tr("Check the information you entered"),
                description: tr(`Faulty phone number`),
                placement: "topRight",
            });
        }

        const res = await axios.post(process.env.REACT_APP_GARDENER_API_END_POINT + '/user/create', {
            emailOrPhone: "90" + invitationEmail,
            role: invitationRole,
            name: invitationName,
        })

        if (res.data.success) {
            setInvitationEmail(null)
            setInvitationName(null)
            setInvitationRole(null)
            notification.success({
                message: tr("User created successfully"),
                description: tr("Invitation has been sent to the user"),
                placement: "topRight"
            })
            queryClient.invalidateQueries('FetchAllUsers')
        } else {
            notification.error({
                message: tr("User creation failed"),
                description: res.data.error,
                placement: "topRight"
            })
        }
    }

    const onInvitationRoleChange = (e) => {
        setInvitationRole(e)
    }

    const onInvitationEmailChange = (e) => {
        const value = e.target.value
        setInvitationEmail(value)
    }

    const onInvitationNameChange = (e) => {
        const value = e.target.value
        setInvitationName(value)
    }

    // const onInvitationPhoneChange = (e) => {
    //     const value = e.target.value
    //     setInvitationPhone(value)
    // }


    return <>
        <div className="text-white h-full">
            <Outlet />
        </div>
    </>
}

export default UserManagement
